import React from "react";

const PrintHeadText = ({ labels, extra }) => {
  return (
    <div className="texts">
      <p><b>وزارت تحصیلات عالی</b></p>
      <b>پوهنتون آریا</b>
      {labels && labels.map((label, i) => <p key={i}>{label}</p>)}
      {extra || null}
    </div>
  );
};

export default PrintHeadText;
